import React from 'react'
import OrderDetailRow from './order-details-row';

const OrderDetails = ({items}) => {
  return (
    <div className="order-details">
      <h4 className="column-title">Order details</h4>

      {items.map((item, index) => <OrderDetailRow key={index} item={item}/>)}
    </div>
  )
};

export default OrderDetails



// WEBPACK FOOTER //
// ./src/components/my-orders/view/order-details.jsx